import { BUTTON__language_change } from '@/pages/_base/layout_header/_buttons/BUTTON__language_change';
import { LAYOUT_COLUMN__left } from '../layout_base/LAYOUT_COLUMN__left';
import { BUTTON__navigation_collections } from '../sidebar_navigation/button_wrappers/BUTTON__navigation_collections';
import { BUTTON__navigation_generation } from '../sidebar_navigation/button_wrappers/BUTTON__navigation_generation';
import { BUTTON__navigation_settings } from '../sidebar_navigation/button_wrappers/BUTTON__navigation_settings';
import { BUTTON__navigation_user_tasks } from '../sidebar_navigation/button_wrappers/BUTTON__navigation_user_tasks';
import { DROPDOWN__help } from './dropdown_help/DROPDOWN__help';

export function FOOTER__navigation() {
  /*
   * RENDERS
   */

  /*
   * HTML
   */

  return (
    <LAYOUT_COLUMN__left>
      <div className="size-full flex flex-col">
        <div className="w-full flex-1 flex flex-row items-center justify-evenly">
          <BUTTON__navigation_user_tasks />
          <BUTTON__navigation_generation />
          <BUTTON__navigation_collections />
        </div>
        <div className="w-full flex-1 flex flex-row items-center justify-evenly">
          <DROPDOWN__help />
          <BUTTON__navigation_settings />
          <BUTTON__language_change button_wrapper_class_name="h-full" />
        </div>
      </div>
    </LAYOUT_COLUMN__left>
  );
}
